import { makeStyles } from '@fluentui/react-components';

/**
 * - `flexSpaceBetween` - A flexbox container with `justify-content: space-between`
 */
export const useSharedStyles = makeStyles({
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});
